/**
 * Minimal client-side session store.
 *
 * "Being authenticated" means an auth token is present in browser storage.
 * The login flow calls `setSession` with the real token; the RequireAuth guard
 * reads from here, so nothing else needs to change.
 *
 * The "Mantener sesión" (remember me) choice picks the storage:
 *  - remember  → localStorage  (survives browser restarts).
 *  - otherwise → sessionStorage (cleared when the tab/window closes).
 * `getToken` looks in both so either choice resolves the same way.
 */
const TOKEN_KEY = 'flik.auth.token';

function readFrom(storage) {
  try {
    return storage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function getToken() {
  return readFrom(window.localStorage) || readFrom(window.sessionStorage);
}

export function isAuthenticated() {
  return Boolean(getToken());
}

export function setSession(token, { remember = true } = {}) {
  const primary = remember ? window.localStorage : window.sessionStorage;
  const secondary = remember ? window.sessionStorage : window.localStorage;
  try {
    primary.setItem(TOKEN_KEY, token);
  } catch {
    /* storage unavailable — ignore */
  }
  // Never leave a stale token behind in the other store.
  try {
    secondary.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

export function clearSession() {
  try {
    window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* storage unavailable — ignore */
  }
  try {
    window.sessionStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}
